import { Colors } from "../constants/colors";

export default {
  variants: [
    {
      props: { fontSize: "xsmall" },
      style: {
        fontSize: 14,
      },
    },
    {
      props: { fontSize: "small" },
      style: {
        fontSize: 18,
      },
    },
    {
      props: { fontSize: "medium" },
      style: {
        fontSize: 24,
      },
    },
    {
      props: { fontSize: "large" },
      style: {
        fontSize: 30,
      },
    },
    {
      props: { fontSize: "xlarge" },
      style: {
        fontSize: 40,
      },
    },
    {
      props: { fontSize: "xxlarge" },
      style: {
        fontSize: 50,
      },
    },
    {
      props: { fontSize: "xxxlarge" },
      style: {
        fontSize: 90,
      },
    },
    {
      props: { fontSize: "banner" },
      style: {
        fontSize: 74,
      },
    },
    {
      props: { fontSize: "launchCardHeader" },
      style: {
        fontSize: 155,
      },
    },
    {
      props: { fontSize: "screenPlaceholder" },
      style: {
        fontSize: 214,
      },
    },
    {
      props: { fontSize: "sizebarNavigation" },
      style: {
        fontSize: 24,
        fill: Colors.GREY450,
      },
    },
    {
      props: { fontSize: "default" },
      style: {
        fontSize: 20
      },
    },
  ],
};
